import { Tabs } from "@mui/material";
import { usePath } from "../libs/path/PathProvider";
import LinkTab from "./LinkTab";
import _ from "lodash";
import MenuButton, { TopRightAnchor } from "../libs/button/MenuButton";

interface IRoute {
    label:string;
    value:string;
}
const Routes : IRoute[] = [
    {label:"Home",value:"/home"},
    {label:"Summary",value:"/summary"},
    {label:"Fixed",value:"/fixed"},
    {label:"Holding",value:"/holding"},
    {label:"Dividends",value:"/dividend"},
    {label:"D.History",value:"/divhist"},
    {label:"Calendar",value:"/calendar"},
    {label:"Sectors",value:"/sector"},
    {label:"Tax",value:"/tax"},
    {label:"History",value:"/history"},
    {label:"Config",value:"/config"},
]

export default function MainTabs(){
    const {path,setPath} = usePath();
    const current = _.findIndex(Routes, (r:IRoute) => r.value==path)<0 ? Routes[0].value : path
    const route = _.find(Routes, r => r.value==path)
    const tabs = Routes.map(route => <LinkTab {...route} key={route.value} href={route.value}/>)
    const onOption = (e:any,path:string) => setPath(path)
    const options = Routes.map(r => ({value:r.value,label:r.label}))
    return <header className="flex horz middle">
        <h2 className="flex1 current">{route?.label || "Home"}</h2>
        <Tabs value={current}>{tabs}</Tabs>
        <MenuButton menuProps={{id:"mainMenu", options, onOption,...TopRightAnchor}} hideWidth={1024}/>
    </header>
}